import BasePage from "@Scripts/Pages/BasePage";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

export default class CheckoutConfirmPage extends BasePage {
    public static async init() {
        await super.init();

        this.setEnhancedEcommerce();
    }

    private static setEnhancedEcommerce() {
        if ((<any>window).App.bag.order) {
            var itemList = [];
            for (var i = 0; i < (<any>window).App.bag.order.orderRows.length; i++) {
                itemList.push({
                    item_id: (<any>window).App.bag.order.orderRows[i].productCode,
                    item_name: (<any>window).App.bag.order.orderRows[i].productDescription,
                    affiliation: "C&DElettronica",
                    currency: "EUR",
                    item_category: (<any>window).App.bag.order.orderRows[i].productCategory,
                    price: (<any>window).App.bag.order.orderRows[i].unitPrice,
                    quantity: (<any>window).App.bag.order.orderRows[i].quantity
                });
            }

            GTagHelper.sendCustomEvent("purchase", {
                currency: "EUR",
                transaction_id: (<any>window).App.bag.order.orderCode,
                value: (<any>window).App.bag.order.orderTotal,
                coupon: (<any>window).App.bag.order.couponCode,
                shipping: (<any>window).App.bag.order.shippingCosts,
                items: itemList
            });
        }
    }
}